module.exports = __webpack_public_path__ + "img/onboarding-icon-1.dc1a1893.svg";